import React, { SyntheticEvent } from 'react';
import ButtonWithIcon from 'components/button-with-icon';
import { AskQuestionIcon } from 'components/icons/ask-qustion-icon';
import { TableComponentsProps } from '../table-components.props';
import { useCreateQuestionModal } from 'hooks/modals/my-vehicles-create-question.modal';
import { useTypedSelector } from 'hooks/use-typed-selector';
import { setForm, setSnakbar, toggleModal } from 'actions/app_action';
import { MODALS } from '../../../../constants';
import useLatestValue from 'hooks/use-latest-value';
import { useDispatch } from 'react-redux';
import { useOverlay } from 'hooks';
import { createNewTaskHandler } from 'utils/create-new-task-handler';

type AskQuestionProps = TableComponentsProps;

export const AskQuestion = ({ row }: AskQuestionProps) => {
  const openCreateQuestionModal = useCreateQuestionModal();

  const dispatch = useDispatch();
  const user = useTypedSelector(state => state.app.user);
  const forms = useTypedSelector(state => state.app.forms);
  const formsLatest = useLatestValue(forms);

  const [showOverlay, hideOverlay] = useOverlay();

  const closeAlert = () => {
    dispatch(toggleModal(MODALS.alert, null));
  };

  const snackbarSetup = (message: string, type: string) => {
    dispatch(setSnakbar({ isOpen: true, message, type }));
  };

  const onClickHandler = (event: SyntheticEvent) => {
    event.stopPropagation();

    openCreateQuestionModal(() => {
      createNewTaskHandler({
        itemId: row?.new_fuhrparkid || '-',
        userId: user.id,
        closeAlert,
        dispatchForm: form => dispatch(setForm(form)),
        formsLatest: formsLatest.current,
        hideOverlay,
        showOverlay,
        snackbarSetup,
        logicalName: 'new_fuhrpark'
      });
    });
  };

  return <ButtonWithIcon tooltip='Frage stellen' icon={<AskQuestionIcon />} onClick={onClickHandler} />;
};
